import { StatusIndicator } from '@/components/ui'
import type { StatusType } from '@/components/ui'
import type { PushNotificationStatus } from './types'

const statusConfig: Record<
  PushNotificationStatus,
  { label: string; status: StatusType }
> = {
  sent: { label: 'Sent', status: 'success' },
  draft: { label: 'Draft', status: 'inactive' },
}

interface StatusBadgeProps {
  status: PushNotificationStatus
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status]

  return (
    <StatusIndicator
      status={config.status}
      label={config.label}
    />
  )
}
